export default "/images/refresh-cw.svg?7880f832e9f84ceda94da61c5cecbd1f";